document.addEventListener("DOMContentLoaded", function () {
    const single = document.getElementById('single');
    if (single) {
        const topics = document.querySelectorAll('.topics');
        topics.forEach((e) => {
            const title = e.querySelector('.title');
            const hs = e.querySelector('.hs');
            const icon = e.querySelector('.icon');

            if (title && hs && icon) {
                title.addEventListener('click', function () {
                    if (hs.style.display === 'none' || hs.style.display === '') {
                        hs.style.display = 'block';
                        title.classList.add('title--open');
                        icon.classList.add('icon--arrow_up');
                    } else {
                        hs.style.display = 'none';
                        title.classList.remove('title--open');
                        icon.classList.remove('icon--arrow_up');
                    }
                });
            }
        });
    }
});